import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class LokalOrderService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getLokalOrderDetails(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminLokalOrder/GetLokalOrderDetails', data, messageService);
    }
}
